// ANETT HORVATH — Notification Bell Component
// In-app notification bell with unread counter.

import { useState } from 'react';
import { useStore } from '../../store/database';
import { getMemberNotifications, getUnreadCount, markRead, markAllRead, type Notification } from '../../modules/notifications';

export default function NotificationBell() {
  const session = useStore(s => s.session);
  const [open, setOpen] = useState(false);

  if (!session?.member_id) return null;

  const unread = getUnreadCount(session.member_id);
  const notifs = getMemberNotifications(session.member_id).slice(0, 10);

  const handleOpen = () => {
    setOpen(!open);
    if (!open && unread > 0) markAllRead(session.member_id!);
  };

  return (
    <div className="relative">
      <button onClick={handleOpen} className="relative p-1.5 text-charcoal/40 hover:text-charcoal transition-colors" aria-label="Notifications">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" />
        </svg>
        {unread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 bg-burgundy text-ivory text-[8px] rounded-full flex items-center justify-center font-sans">{unread > 9 ? '9+' : unread}</span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-64 bg-ivory border border-charcoal/10 shadow-lg z-50 max-h-72 overflow-y-auto">
          {notifs.length === 0 ? (
            <p className="p-4 text-[11px] text-charcoal/40 font-sans text-center">No notifications</p>
          ) : notifs.map(n => (
            <div key={n.id} className={`px-3 py-2 border-b border-charcoal/5 ${!n.read_at ? 'bg-gold/5' : ''}`}>
              <p className="text-[11px] font-sans font-medium text-charcoal">{n.type.replace('_', ' ')}</p>
              <p className="text-[10px] text-charcoal/30 font-sans">{new Date(n.created_at).toLocaleString()}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
